import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-weatherAlertsTime",
  "use": "icon-weatherAlertsTime-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-weatherAlertsTime\"><path d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z\" fill=\"#4066D4\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.997 4.8a1.2 1.2 0 0 1 1.2 1.2v5.4l4.32 3.24a1.2 1.2 0 0 1-1.44 1.92l-4.8-3.6a1.2 1.2 0 0 1-.48-.96V6a1.2 1.2 0 0 1 1.2-1.2Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol